import { DateTime } from 'luxon';

export const formatDateTime = (dateTime: string, format: string) => {
  const date = DateTime.fromISO(dateTime);
  return date.toFormat(format);
};
